export var getCarouselSizeView = function getCarouselSizeView(_ref) {
  var isMobile = _ref.isMobile,
    isDesktop = _ref.isDesktop;
  if (isMobile) {
    return 'auto';
  }
  if (isDesktop) {
    return 2;
  }
  return 1;
};